export const habaProduct = {
  habaProductCard: {
    newTag: 'NOUVEAU',
    sustainableTag: 'Durable',
    color: 'Couleurs',
    aiImageAlt: 'Image générée par IA',
  },
  habaProductDetails: {
    technicalData: 'Technical Data',
    addToCart: 'Ajouter au panier',
    quantity: 'Quantité',
    descriptionMoreLink: 'Détails du produit',
    descriptionHeadline: 'Détails du produit',
    taxDelivery: 'TVA incluse /',
    taxDeliveryLink: 'Expédition',
    freeDelivery: 'livraison gratuite',
    outOfStock: 'Plus disponible',
    shareProduct: 'Partager le produit',
    linkCopy: 'Copier le lien',
    linkCopied: 'Lien copié',
    linkCopyFailed: 'Échec de la copie du lien',
    isNoMoreFixedBookPrice: "L'ancien système de prix imposés pour les livres est supprimé",
    personalize: {
      openButton: 'Personnaliser le produit',
      justForYou: 'Juste pour toi',
      title: 'Personnaliser le produit',
      remove: 'Supprimer',
      save: 'AJOUTER AU PANIER',
      cannotReturn:
        'Nous vous prions de comprendre que les articles personnalisés ne peuvent être ni échangés ni retournés.',
      inputPlaceholder: 'Veuillez saisir le texte de la ligne {{index}}',
      informationSpace: 'Espace pour tes données:',
      linesAndLength: '{{lines}} ligne(s) à {{length}} caractères',
      priceLine:
        'Nous personnalisons cet article pour <b>{{price}} par pièce</b> selon tes souhaits.',
      script: 'Écriture cursive',
      block: 'Écriture imprimée',
      wrongCharacters: 'Les caractères spéciaux ne sont pas autorisés.',
    },
    pleaseSelectAmount: 'Veuillez sélectionner un montant:',
    enterAmount: 'Saisir le montant',
    selectedVoucherValue: 'Valeur du bon sélectionnée',
    articleNumber: "Numéro d'article:",
    manufacturer: 'Fabricant',
    specifications: {
      recommendedAge: 'Âge recommandé',
      numberOfPlayers: 'Nombre de joueurs',
      playingTime: 'Durée du jeu',
      playingTimeRange: 'env. {{min}} – {{max}} minutes',
      playingTimeSingle: 'env. {{value}} minutes',
      productDimensions: 'Dimensions du produit',
      weight: 'Poids',
      author: 'Auteur·rice',
      authors: 'Auteur·rice·s',
      illustration: 'Illustration',
      dimensionAbbr: {
        height: 'H',
        width: 'l',
        depth: 'P',
        length: 'L',
      },
    },
    downloadInstructions: 'Télécharger les instructions',
    classificationYes: 'Oui',
    classificationNo: 'Non',
    content: 'Contenu',
    instructions: "Matériaux & conseils d'entretien",
    returnInformation: 'Retour gratuit dans un délai de <b>4 semaines</b>',
    certificate: {
      certifiedBy: 'Certifié par',
      licenceNumber: "Numéro d'immatriculation",
    },
    ratingProduct: {
      modalButton: 'Évaluez le produit',
      rateProduct: 'Évaluez ce produit',
      yourRating: 'Ton évaluation du produit*',
      ratingDescription: "Description de l'examen du produit*",
      descriptionError: 'Ce champ est obligatoire et doit contenir entre 1 et 400 caractères',
      additionalInformation:
        'En soumettant, vous acceptez les <a href="{{guidelinesUrl}}" class="font-xs font-md-s" target="_blank" rel="noopener noreferrer">directives HABA</a> concernant les avis.',
      submitReview: 'Poster le commentaire',
      successfulTitle: 'Merci pour votre avis!',
      successfulText:
        'Votre avis est en cours de traitement. Nous vous informerons par e-mail une fois que votre avis sera visible sur la page produit.',
      backToProductButton: 'Retour au produit',
    },
    sort: {
      sortBy: 'Trier par',
      date: 'Date',
      highestRating: 'Note la plus élevée',
      lowestRating: 'Note la plus basse',
    },
    sizeTable: {
      baby: 'Bébés',
      girl: 'Filles',
      unisex: 'Garçons',
      hat: 'Chapeaux',
      shoe: 'Chaussures',
      glove: 'Gants',
    },
    msrp: 'MSRP',
    shippingConditionsText:
      "Pour les frais de port et d'emballage, nous facturons un forfait de <b>4,95 €</b>.<br><br>À partir de 49 € votre commande est <b>LIVRAISON GRATUITE !</b>",
  },
  habaProductVariants: {
    color: 'Couleur',
    size: 'Taille',
    chooseSize: 'Choisir la taille',
    soldOut: 'Épuisé',
    notifyMe: 'Avertir',
    toSizeTable: 'Vers le tableau des tailles',
    selectSize: 'Choisir la taille',
  },
  habaProductPersonalization: {
    personalisation: 'Personalisierung',
    spaceForInformation: 'Platz für deine Angaben',
    font: 'Schriftart',
    entries: 'Deine Angaben',
    remove: 'Remove',
    edit: 'Edit',
    successfullyAddedTitleNotification: 'Produkt erfolgreich personalisiert',
    successfullyAddedMessageNotification:
      'Der Preis wurde einschließlich der Personalisierungskosten aktualisiert',
    successfullyRemovedTitleNotification: 'Product personalization',
    successfullyRemovedMessageNotification: 'Was removed succesfully',
    headline: 'Add personalization',
    subheadline:
      'We personalize this item for an additional charge of <strong>7,50 € per piece</strong> according to your specifications.',
    blockWriting: 'Druckschrift',
    handWriting: 'Schreibschrift',
    errorTextLimitation: 'Space for your details: 1 line of 20 characters',
    textInputLabel: 'Please enter your personalized text *',
    exclusionLabel:
      'Please understand that personalized items are excluded from the exchange and return policy.',
    close: 'Abbrechen',
    submit: 'Speichern',
  },
};
